export default "__VITE_ASSET__BcwXwcgp__"